import { convertToPrimitive } from '@/utils/tools'

class LocalStorageAdapter {
  set(key, value) {
    const processedValue = typeof value === 'object' ? JSON.stringify(value) : value

    window.localStorage.setItem(key, processedValue)
  }

  get({ key = '', desiredType = String, defaultValue = null }) {
    const storedValue = window.localStorage.getItem(key)
    // eslint-disable-next-line new-cap
    const returnableDefault = defaultValue ?? (desiredType === String ? '' : new desiredType())

    return storedValue
      ? LocalStorageAdapter._convertToIntendedType(storedValue, desiredType)
      : returnableDefault
  }

  remove(key) {
    window.localStorage.removeItem(key)
  }

  /* eslint-disable indent */
  static _convertToIntendedType(value, type) {
    switch (type) {
      case Array:
      case Object:
        try {
          return JSON.parse(value)
        } catch (e) {
          return Array.isArray(type) ? [] : {}
        }
      default:
        return convertToPrimitive(value, type)
    }
  }
  /* eslint-enable indent */
}

export default new LocalStorageAdapter()
